/**
 * User: herbert
 * Date: 25.11.15
 * Time: 11:06
 */


// die ganz saubere art wäre dass der ConfigBar aus der Konfiguration berechnet wird,
// wobei er diese zusammen mit einem bound-handler für jedes element von der übergeordneten index.jsx bekommt
// die dort erstellten boundhandler kennen die ebenfalls von index.jsx erstelle Stele-Komponente
// und können in dieser direkt das draggen des gewählten elements auslösen

// alternative nicht ganz so schöne direkte verdrahtung: eine ref auf die stele setzen und in componentDidMount/Render
// an die configbar weiterreichen. diese muss dann einen setState auf sich ausführen, was dort einen render auslöst. nicht schön

// weiter alternive, die sogar schöner ist: index.jsx binded an sich selbst. die zugrunde liegende funktion wird erst nach dem render
// aufgerufen, dh. wenn der ref auf die stele gesetzt ist
// => This way we go
// der configbar bekommt einen Array mit { className: '', onclick: xx }



/**
 * Offers various scopes and sets background and defaults in foreign stores
 *
 * User: herbert
 * Date: 25.11.15
 * Time: 11:11
 */

import Reflux from 'reflux';
import * as config from '../../../config';

export default Reflux.createActions({
	/** @param{Number} scope index 0..3 */
	resetToScopes: {},
	/** @param{Number} scope index 0..3 */
	hoverScope: {},

	/** clear stele and forget about preselected scope */
	clear: {},

	/** reset to last remembered scope */
	resetToLastScopes: {},

	/**
	 * @param{Number} parentIdx index of parent element to change
	 * @param{StelePartCfg} model config entry to change size to, i.e. take name, mountNew, enabled, container from it and merge with fitting entries from partenIdx' children
	 */
	changeSize: {},

	/**
	 * @param{Number} parentIdx index of parent element which backCover value should be toggled
	 */
	toggleBack: {},
	/**
	 * @param{Number} parentIdx index of parent element which backCover value should be toggled
	 * @param{Number} newRotation rotation of parent element to set
	 */
	setRotation: {},
	/**
	 * @param{String} color	color as CSS-named color of defined as rgb(r,g,b) but NOT as #xxxxxx
	 */
	setFinish: {},
	/**
	 * set global rotation
	 * @param{Number} globalRotation new value of global rotation
	 */
	setGlobalRotation: {},
	/**
	 * set light distribution type
	 * @param type
	 * @param{Number} parentIdx
	 * @param{Number} [childIdx]
	 * @param{Boolean} [spotA]
	 */
	setType: {},
	/**
	 * set x-y position of one of spots of TwinSpot
	 * @param{Number} x
	 * @param{Number} y
	 * @param{Number} parentIdx
	 * @param{Number} childIdx
	 * @param{Boolean} spotA
	 */
	setXY: {},
	/**
	 * set power of Gobo
	 * @param{String} power
	 * @param{Number} parentIdx
	 * @param{Number} childIdx
	 */
	setPower: {},
	/**
	 * set horiz or vert of Fassade
	 * @param direction
	 * @param{Number} parentIdx
	 * @param{Number} childIdx
	 * @param{Boolean} horiz
	 */
	setDirection: {},
	/** set height over all
	 * @param{Number} h height over all in mm
	 */
	setHeight: {},
	/** set light color of TwinSpot, Fassade, Vertikal or Wege
	 * @param{Boolean} k3000 3000K if k3000 evaluates to true, else 4000K
	 * @param{Number} parentIdx index of the target Wege module or of the target's parent
	 * @param{Number} [childIdx] child-index of the target if Fassade or TwinSpot
	 */
	setK3000: {},
	/**
	 * new color setter for pieces supporting 2kK-colors
	 * @param k2xxx if true k3000 switches beetween 2200K and 2700K instead of 3000K and 4000K
	 * @param k3000 if k2xxx is false, true is 3000K and false is 4000K, if k2xxx is true a true here means 2200K and a false 2700K
	 * @param parentIdx
	 * @param childIdx
	 */
	setLightColor: {},
	/**
	 * set tritec sky reflector instead of a ambience one
	 * @param{Boolean} sky
	 * @param{Number} parentIdx
	 * @param{Number} [childIdx]
	 */
	setSky: {},
	/**
	 * set tritec reflector gold instead of a silver one
	 * @param{Boolean} gold
	 * @param{Number} parentIdx
	 * @param{Number} [childIdx]
	 */
	setGold: {},
	/** set if stele base should feature a 'Kabelkasten'
	 * @param{Boolean} kasten true if stele base features a 'Kabelkasten', else false
	 */
	setKasten: {},
	/** set if stele base should feature a second or third additional door. Feb 2018: only one additional door is available
	 * @param{Number} number of additional doors, ie. the value 1 brings in the 2nd door
	 */
	setExtraDoors: {},
	/** set count of charging stations, may remove them at all
	 * @param{Number} count count of charging stations, 0, 1 or 2
	 */
	setChargingCount: {},
	/** set type of charging stations,
	 * @param{String} type type of charging stations, any of config.C_TYPE_*
	 */
	setChargingType: {},
	/** set power option of charging stations,
	 * @param{String} power power option of charging stations, any of config.C_POWER_*
	 */
	setChargingPower: {},
	/** set count of charging stations, may remove them at all
	 * @param{Number} position number of position to set
	 *					if count == 1 allowed values: 0, 1, 2
	 *				    if count == 2 allowed values: 0, 1
	 *				    if count == 3 allowed value: 0
	 */
	setChargingPositioning: {}
});
